import { Typography } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { JobconfigSupplierComparisonArrowIcon } from 'components/Icons';
import { RevxButton } from 'components/RevxButton';
import RevxFlexLayout from 'components/RevxFlexLayout';
import {
  JobComparatorPart,
  JobComparatorSvc,
  JobEstimator,
  JobEstimatorComparatorItem,
  JobSpec,
  PopoverType,
  SearchScopeEnum,
} from 'domains/jobconfigDomain';
import { useJobRevision } from 'hooks/useJobRevision';
import { isNumber } from 'lodash-es';
import { useMemo } from 'react';
import { Trans } from 'react-i18next';
import { useHistory } from 'react-router-dom';

interface ISupplierComparisonLabel {
  maxLabel: number;
  showJobEstimator: {
    list: JobEstimatorComparatorItem[];
    partLabel: JobComparatorPart[];
    svcLabel: JobComparatorSvc[];
    rush?: boolean;
  };
  clickToggle: (x: string) => void;
  isClickToggle: (x: string) => boolean;
  boxHeight: number;
  canAddToCart: boolean;
  jobEstimator: JobEstimator | undefined;
  popoverType: PopoverType | undefined;
  popoverHeight: number | undefined;
  popoverVisible: number | false;
  revisionId: number;
  spec?: JobSpec;
}

export const SupplierComparisonLabel = (props: ISupplierComparisonLabel) => {
  const { maxLabel } = props;
  return (
    <RevxFlexLayout
      direction="column"
      className="comparison-drawer-label"
      style={{
        maxWidth: `${maxLabel}px`,
        minWidth: '220px',
      }}
    >
      <SupplierComparisonLabelTitle {...props} />

      <SupplierComparisonLabelPart {...props} />

      <SupplierComparisonLabelSvc {...props} />

      <SupplierComparisonLabelGlobalMarkup />

      <SupplierComparisonLabelSubtotal />

      <SupplierComparisonLabelSubtotalMarkup />

      <SupplierComparisonLabelShipping {...props} />

      <SupplierComparisonLabelAction {...props} />
    </RevxFlexLayout>
  );
};

export const SupplierComparisonLabelTitle = (
  props: ISupplierComparisonLabel
) => {
  const { canAddToCart, jobEstimator, showJobEstimator } = props;
  const dispatch = useAppDispatch();
  const history = useHistory();

  const isRush = useMemo(() => {
    return Boolean(showJobEstimator?.rush);
  }, [showJobEstimator?.rush]);
  return (
    <>
      <RevxFlexLayout
        className={`comparison-drawer-rfq`}
        justify="justify-center"
        align="center"
      >
        <RevxButton
          size="small"
          type="primary"
          brandOrange
          className="comparison-drawer-rfq-button"
          style={{
            fontSize: '11px',
          }}
          hidden={canAddToCart}
          // disabled={showJobEstimator.list.length === 1}
          // hidden={rush}
          onClick={async () => {
            if (jobEstimator?.jobConfigId) {
              try {
                await dispatch.jobConfig.sendToSourcer(
                  jobEstimator?.jobConfigId
                );
                history.push('/workspace');
              } catch {}
            }
          }}
        >
          <Trans i18nKey={'jobConfig.sendToCustomerService'}></Trans>
        </RevxButton>
      </RevxFlexLayout>
      <RevxFlexLayout
        align="center"
        justify="right"
        hidden={!isRush}
        className={`comparison-drawer-part-service comparison-drawer-part-service-label ${
          isRush ? 'comparison-drawer-rush' : ''
        }`}
        style={{
          height: '38px',
          textAlign: 'right',
        }}
      >
        <span>User Requested Arrival Date</span>
      </RevxFlexLayout>
    </>
  );
};

export const SupplierComparisonLabelPart = (
  props: ISupplierComparisonLabel
) => {
  const { showJobEstimator, clickToggle, isClickToggle, spec } = props;

  return (
    <>
      {showJobEstimator?.partLabel?.map((part, index) => {
        return (
          <RevxFlexLayout
            direction="column"
            className="comparison-drawer-part"
            key={part.skuId}
          >
            <RevxFlexLayout
              justify="right"
              className="comparison-drawer-part-label"
              onClick={() => clickToggle(part.skuName)}
            >
              <span>
                {part.pageCount
                  ? `${part.skuName} (${part.pageCount})`
                  : part.skuName}
              </span>
              <JobconfigSupplierComparisonArrowIcon
                className={
                  !isClickToggle(part.skuName)
                    ? 'comparison-drawer-check-icon'
                    : ''
                }
              />
            </RevxFlexLayout>
            <RevxFlexLayout
              align="center"
              justify="right"
              className="comparison-drawer-part-press comparison-drawer-part-press-label"
              hidden={!isClickToggle(part.skuName)}
            >
              <span>Press</span>
            </RevxFlexLayout>
            <RevxFlexLayout
              align="center"
              justify="right"
              className="comparison-drawer-part-service comparison-drawer-part-service-label"
              hidden={!isClickToggle(part.skuName)}
              style={
                {
                  // marginBottom: part.svcs.length ? '' : '10px',
                }
              }
            >
              <span>Paper</span>
            </RevxFlexLayout>
            {spec?.parts[index].paperSearchScope ===
              SearchScopeEnum.MY_PAPER && (
              <RevxFlexLayout
                justify="right"
                className=" comparison-drawer-part-label no-background"
              >
                <span>Find comparable paper {'>'}</span>
              </RevxFlexLayout>
            )}

            {part.svcs.map((svc) => {
              return (
                <RevxFlexLayout
                  key={svc.name + svc.charge}
                  align="center"
                  justify="right"
                  className="comparison-drawer-part-service comparison-drawer-part-service-label"
                  hidden={!isClickToggle(part.skuName)}
                >
                  <span>{svc.name}</span>
                </RevxFlexLayout>
              );
            })}
          </RevxFlexLayout>
        );
      })}
    </>
  );
};

export const SupplierComparisonLabelSvc = (props: ISupplierComparisonLabel) => {
  const { clickToggle, isClickToggle, showJobEstimator, boxHeight } = props;
  return (
    <RevxFlexLayout direction="column" className="comparison-drawer-wrapper">
      <RevxFlexLayout
        justify="right"
        className="comparison-drawer-part-label comparison-drawer-wrapper-label"
        onClick={() => clickToggle('Services')}
      >
        <span>Services</span>
        <JobconfigSupplierComparisonArrowIcon
          className={
            !isClickToggle('Services') ? 'comparison-drawer-check-icon' : ''
          }
        />
      </RevxFlexLayout>
      {showJobEstimator.svcLabel.map((svc, idx) => {
        return (
          <RevxFlexLayout
            align="center"
            justify="right"
            key={svc.charge + svc.name}
            className="comparison-drawer-wrapper-service comparison-drawer-wrapper-service-label"
            hidden={!isClickToggle('Services')}
            style={{
              marginTop: idx === 0 ? '16px' : '',
            }}
          >
            <Typography.Title
              style={{
                fontSize: '13px',
                marginBottom: 0,
                maxWidth: `150px`,
              }}
              ellipsis={{
                tooltip: svc.name,
              }}
            >
              {svc.name}
            </Typography.Title>
          </RevxFlexLayout>
        );
      })}
      <RevxFlexLayout
        align="top"
        justify="right"
        className="comparison-drawer-wrapper-service comparison-drawer-wrapper-service-parcel"
        hidden={!isClickToggle('Services')}
        style={{
          paddingTop: '10px',
          height: `${boxHeight}px`,
          marginBottom: '16px',
          minHeight: '0px',
        }}
      >
        <span>Box Charge</span>
      </RevxFlexLayout>
    </RevxFlexLayout>
  );
};

export const SupplierComparisonLabelGlobalMarkup = () => {
  return (
    <RevxFlexLayout
      justify="right"
      className="comparison-drawer-subtotal comparison-drawer-subtotal-markup-label"
    >
      <span>Global Markup</span>
    </RevxFlexLayout>
  );
};

export const SupplierComparisonLabelSubtotal = () => {
  return (
    <RevxFlexLayout justify="right" className="comparison-drawer-subtotal">
      <span>Subtotal</span>
    </RevxFlexLayout>
  );
};

export const SupplierComparisonLabelSubtotalMarkup = () => {
  return (
    <RevxFlexLayout
      align="center"
      justify="right"
      className="comparison-drawer-wrapper-service comparison-drawer-wrapper-service-label"
      style={{
        height: '60px',
      }}
    >
      <span>Product Markup/Discount</span>
    </RevxFlexLayout>
  );
};

export const SupplierComparisonLabelShipping = (
  props: ISupplierComparisonLabel
) => {
  const {
    clickToggle,
    isClickToggle,
    popoverHeight,
    popoverVisible,
    popoverType,
  } = props;
  const popverStyle = useMemo(() => {
    return isNumber(popoverVisible) && popoverType === PopoverType.shipping;
  }, [popoverVisible, popoverType]);
  return (
    <RevxFlexLayout direction="column" className="comparison-drawer-wrapper">
      <RevxFlexLayout
        justify="right"
        className="comparison-drawer-part-label comparison-drawer-wrapper-label"
        onClick={() => clickToggle('Shipping Total')}
      >
        <span>Shipping Total</span>
        <JobconfigSupplierComparisonArrowIcon
          className={
            !isClickToggle('Shipping Total')
              ? 'comparison-drawer-check-icon'
              : ''
          }
        />
      </RevxFlexLayout>

      <RevxFlexLayout
        align="center"
        justify="right"
        className="comparison-drawer-part-service comparison-drawer-part-service-label"
        hidden={!isClickToggle('Shipping Total')}
      >
        <span>
          <Trans i18nKey="rfq.supplier.readyDate"></Trans>
        </span>
      </RevxFlexLayout>

      <RevxFlexLayout
        align="center"
        justify="right"
        className="comparison-drawer-part-service comparison-drawer-part-service-label"
        hidden={!isClickToggle('Shipping Total')}
      >
        <span>Shipping</span>
      </RevxFlexLayout>

      <RevxFlexLayout
        align="center"
        justify="right"
        className="comparison-drawer-part-service comparison-drawer-part-service-label"
        hidden={!isClickToggle('Shipping Total')}
        style={{
          marginTop: popverStyle ? (popoverHeight || 0)! + 10 : 0,
        }}
      >
        <span>Shipping Markup/Discount</span>
      </RevxFlexLayout>

      <RevxFlexLayout
        align="center"
        justify="right"
        className="comparison-drawer-part-service comparison-drawer-part-service-label"
        hidden={!isClickToggle('Shipping Total')}
        style={{
          height: '38px',
        }}
      >
        <span>Date Ready</span>
      </RevxFlexLayout>

      <RevxFlexLayout
        align="center"
        justify="right"
        className="comparison-drawer-part-service comparison-drawer-part-service-label"
        hidden={!isClickToggle('Shipping Total')}
        style={{
          height: '38px',
        }}
      >
        <span>Arrival Date</span>
      </RevxFlexLayout>
    </RevxFlexLayout>
  );
};

export const SupplierComparisonLabelAction = (
  props: ISupplierComparisonLabel
) => {
  const { canAddToCart, revisionId } = props;
  const isEstimated = useMemo(() => {
    return Boolean(!canAddToCart);
  }, [canAddToCart]);
  const isJobRevision = useJobRevision(props);
  const dispatch = useAppDispatch();
  const history = useHistory();
  const uiStatusFilter = useAppSelector(
    (state) => state.workspace.uiStatusFilter
  );
  const cancelJobHandler = async () => {
    try {
      await dispatch.jobConfig.jobRevisionCancel(revisionId);
    } catch {}
    history.push(`/workspace/${uiStatusFilter}`);
  };
  return (
    <>
      <RevxFlexLayout
        align="center"
        justify="right"
        className="comparison-drawer-part-label comparison-drawer-wrapper-label comparison-drawer-total"
        style={{
          marginBottom: isJobRevision ? 0 : 170,
        }}
      >
        <label>
          {isEstimated ? (
            <Trans i18nKey="jobConfig.stepViewQuote.estimatedJobCosts"></Trans>
          ) : (
            <Trans i18nKey="jobConfig.stepViewQuote.jobNetTotal"></Trans>
          )}
        </label>
      </RevxFlexLayout>
      <RevxFlexLayout
        align="bottom"
        justify="left"
        direction="column"
        className="comparison-drawer-body-action"
        hidden={!isJobRevision}
        style={{
          width: '100%',
          paddingLeft: 26,
          paddingRight: 26,
        }}
      >
        <RevxButton
          brandGreen
          style={{ width: 120 }}
          // className="btn-supplier-comparison"
          onClick={() => cancelJobHandler()}
        >
          <Trans i18nKey="common.cancel"></Trans>
        </RevxButton>
      </RevxFlexLayout>
    </>
  );
};
